<div class="admin-modal">
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;"
         (click)="toggleMinimise()"></i>
      <i class="fa fa-times" style="cursor: pointer;" (click)="cancel()"></i>
    </div>
  </div>

  <div class="modal-body" [hidden]="minimise">
    <div class="row">
      <div class="col-md-2 payload-label">Notify ID</div>
      <div class="col-md-10 payload-id">{{ notificationId || '—' }}</div>
    </div>
    <div class="row">
      <div class="col-md-2 payload-label">Payload</div>
      <div class="col-md-10">
        <pre class="payload-view">{{ payloadView || 'No payload available' }}</pre>
      </div>
    </div>
  </div>

  <div class="modal-footer" [hidden]="minimise">
    <button class="btn btn-info btn-sm" type="button" (click)="resendNotification()" [disabled]="resending">
      @if (resending) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
      Resend
    </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
